import React, { useEffect, useRef, useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Button, Typography, Box, CircularProgress } from '@mui/material';

// Компонент для авторизации через Telegram
const TelegramLoginButton = ({ botName }) => {
  const { loginWithTelegram } = useAuth();
  const containerRef = useRef(null);
  const scriptRef = useRef(null);
  const [loadingWidget, setLoadingWidget] = useState(true);
  const [widgetError, setWidgetError] = useState(null);

  useEffect(() => {
    console.log('TelegramLoginButton: Инициализация с botName:', botName);
    
    if (!botName) {
      console.error('TelegramLoginButton: Имя бота не указано!');
      setWidgetError('Имя бота не указано в конфигурации');
      setLoadingWidget(false);
      return;
    }
    
    // Определяем функцию авторизации в глобальном объекте window
    window.onTelegramAuth = (user) => {
      console.log('TelegramLoginButton: Получены данные авторизации:', user);
      try {
        loginWithTelegram(user);
      } catch (error) {
        console.error('TelegramLoginButton: Ошибка при обработке данных авторизации:', error);
        setWidgetError('Ошибка при обработке данных авторизации');
      }
    };

    // Загрузка Telegram виджета
    const script = document.createElement('script');
    scriptRef.current = script;
    script.src = 'https://telegram.org/js/telegram-widget.js?22';
    script.setAttribute('data-telegram-login', botName);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-radius', '4');
    script.setAttribute('data-onauth', 'onTelegramAuth(user)');
    script.setAttribute('data-request-access', 'write');
    script.async = true;
    
    // Обработчики загрузки и ошибки
    script.onload = () => {
      console.log('TelegramLoginButton: Виджет успешно загружен');
      setLoadingWidget(false);
    };
    
    script.onerror = (error) => {
      console.error('TelegramLoginButton: Ошибка загрузки виджета:', error);
      setWidgetError('Не удалось загрузить виджет Telegram');
      setLoadingWidget(false);
    };

    // Добавляем скрипт на страницу, если контейнер существует
    if (containerRef.current) {
      console.log('TelegramLoginButton: Добавление скрипта в DOM');
      containerRef.current.innerHTML = ''; // Очищаем контейнер перед добавлением
      containerRef.current.appendChild(script);
    } else {
      console.error('TelegramLoginButton: Контейнер не найден!');
      setWidgetError('Ошибка инициализации виджета');
      setLoadingWidget(false);
    }

    return () => {
      console.log('TelegramLoginButton: Очистка компонента');
      // Удаляем скрипт и обработчик при размонтировании компонента
      if (containerRef.current && scriptRef.current && containerRef.current.contains(scriptRef.current)) {
        containerRef.current.removeChild(scriptRef.current);
      }
      delete window.onTelegramAuth;
    };
  }, [botName, loginWithTelegram]);

  // Если бот уже известен, показываем альтернативную кнопку входа
  const handleManualLogin = () => {
    const mockUser = {
      id: 12345678,
      first_name: 'Тестовый',
      last_name: 'Пользователь',
      username: 'test_user',
      photo_url: '',
      auth_date: Math.floor(Date.now() / 1000)
    };
    console.log('TelegramLoginButton: Ручной вход с данными:', mockUser);
    loginWithTelegram(mockUser);
  };

  return (
    <Box>
      {loadingWidget && (
        <Box sx={{ display: 'flex', justifyContent: 'center', my: 2 }}>
          <CircularProgress size={24} />
          <Typography variant="body2" sx={{ ml: 1 }}>
            Загрузка виджета авторизации...
          </Typography>
        </Box>
      )}
      
      {widgetError && (
        <Typography color="error" variant="body2" sx={{ mb: 2 }}>
          {widgetError}
        </Typography>
      )}
      
      <div id="telegram-login-container" ref={containerRef} style={{ marginBottom: '16px' }}></div>
      
      {/* Альтернативная кнопка для отладки */}
      {process.env.NODE_ENV === 'development' && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" sx={{ display: 'block', mb: 1 }}>
            Для разработки/отладки:
          </Typography>
          <Button 
            variant="outlined" 
            color="primary" 
            onClick={handleManualLogin}
            size="small"
          >
            Войти как тестовый пользователь
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default TelegramLoginButton; 